import React from 'react';
import './App.css';
import PrivacyPage from './PrivacyPage';

function App() {
  return (
    <div className="App">
      <PrivacyPage />
    </div>
  );
}

export default App;
